import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import Navbar from '../components/common/Navbar';
import LoadingSpinner from '../components/common/LoadingSpinner';
import Profile from '../components/profile/Profile';
import {
  getProfile,
  updateProfile,
  updateAvatar,
  deleteAvatar,
  changePassword
} from '../services/api';
import './ProfilePage.css';

const ProfilePage = () => {
  const { user, isAuthenticated, logout, checkAuth } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadProfile = useCallback(async () => {
    try {
      setProfile(await getProfile());
      setError('');
    } catch (e) {
      setError('Не удалось загрузить профиль');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadProfile(); }, [loadProfile]);

  const handleSave = async (payload) => {
    await updateProfile(payload);
    await loadProfile();
    // Имя и аватар видны в шапке — обновляем данные сессии
    if (payload.full_name !== undefined) await checkAuth();
  };

  const handleSaveAvatar = async (dataUrl) => {
    await updateAvatar(dataUrl);
    await loadProfile();
  };

  const handleDeleteAvatar = async () => {
    await deleteAvatar();
    await loadProfile();
  };

  const handleChangePassword = async (current, next) => {
    await changePassword(current, next);
  };

  if (!isAuthenticated) return null;

  return (
    <div className="profile-page">
      <Navbar user={user} isAdmin={user?.role === 'admin'} onLogout={logout} />

      {loading && <LoadingSpinner />}

      {!loading && error && (
        <div className="profile-page-error">
          {error}
          <button type="button" className="ui-btn-primary" onClick={loadProfile}>
            Попробовать снова
          </button>
        </div>
      )}

      {!loading && profile && (
        <Profile
          profile={profile}
          onSave={handleSave}
          onSaveAvatar={handleSaveAvatar}
          onDeleteAvatar={handleDeleteAvatar}
          onChangePassword={handleChangePassword}
          onLogout={logout}
        />
      )}
    </div>
  );
};

export default ProfilePage;
